<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main hcd_main">
        <SubTitleComponent :title="title" :type="''"></SubTitleComponent>
        <div class="box">
          <el-descriptions title="" direction="" :column="1" border>
            <el-descriptions-item label="行业类型">{{ customerData.type }}</el-descriptions-item>
            <el-descriptions-item label="项目类型">{{ customerData.project }}</el-descriptions-item>
            <el-descriptions-item label="项目地址">{{ customerData.address }}</el-descriptions-item>
            <el-descriptions-item label="项目面积">{{ customerData.square }}平方米</el-descriptions-item>
            <el-descriptions-item label="风格偏好">{{ customerData.style }}</el-descriptions-item>
            <el-descriptions-item label="设计理念">{{ customerData.design }}</el-descriptions-item>
            <el-descriptions-item :label="'项目图('+customerEffect.length+'张)'" labelStyle="width: 80px;">
              <div class="renderBox" v-if="customerEffect.length > 0">
                <div class="item" v-for="(item,index) in customerEffect" @click="toDetail(index)">
                  <img :src="item.photo_url + '?x-oss-process=image/resize,m_fill,w_300,h_300'" alt="">
                  <div class="name">{{ item.title }}</div>
                </div>
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <el-dialog
          v-if="dialogVisible == 'detail'"
          :visible.sync="dialogVisit"
          top="15vh"
          :show-close="false"
          :center="true"
          :closeDetail="closeDetail">
          <div class="img" v-if="dialogCur != -1">
            <img :src="customerEffect[dialogCur].photo_url" alt="">
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>
  
<script>
const imgDemo = require('../../assets/pic_xgt.jpg')

const renderData = [{
  id: '1',
  name: '前厅',
  count: '2',
  imgData: [{
    img: imgDemo,
    name: '效果图1'
  },{
    img: imgDemo,
    name: '效果图2'
  },{
    img: imgDemo,
    name: '效果图2'
  },{
    img: imgDemo,
    name: '效果图2'
  }]
},{
  id: '2',
  name: '工位',
  count: '2',
  imgData: [{
    img: imgDemo,
    name: '效果图1'
  },{
    img: imgDemo,
    name: '效果图2'
  }]
}]

export default {
  name: 'CustomerHistoryDetail',
  components: {},
  data() {
    return {
      id: 0,
      title: '历史客户详情',
      customerData: {
        id: '',
        name: '',
        type: '',
        project: '',
        address: '',
        square: '',
        style: '',
        design: '',
        rendering: [],
      },
      searchValue: '',
      customerEffect: [],
      dialogVisible: '',
      dialogVisit: false,
      dialogCur: -1,
    }
  },
  created() {
    console.log(this.$route.params.id); // 打印出 URL 中的 id 参数
    let _id = this.$route.params.id
    this.customerData.id = _id
    this.getData()
  },
  mounted() {
    _ajaxType = 0
    // this.customerData.rendering = renderData
  },
  methods: {
    handleDetal(index, row) {
      console.log(index, row);
    },
    getData(){
      let _id = this.customerData.id
      let _url = "/api/?mod=history_client&action=detail"
      let _clientData = {
        history_client_id: _id
      }
      // console.log(this.axios)
      this.axios.post(_url, _clientData).then(json => {
        // 获取
        let _data = json.data.data
        console.log("customerHistoryData", _data);
        if (json.data.errcode == 0) {
          this.customerData.type = _data.industry_type
          this.customerData.project = _data.project_type
          this.customerData.address = _data.project_address
          this.customerData.square = _data.project_area
          this.customerData.style = _data.style_type
          this.customerData.design = _data.design_concept
          this.customerEffect = _data.effect

          // let _render = []
          // for(let i=0;i<_data.effect.length;i++){
          //   let _array = {
          //     id: i,
          //     title: _data.effect[i].space_type,
          //     count: _data.effect[i].photo.length,
          //     imgData: _data.effect[i].photo
          //   }
          //   _render.push(_array)
          // }

          // this.customerData.rendering = _render
        }
        console.log(json.data);
      })
    },
    closeDetail(e) {
      this.dialogCur = -1
      this.dialogVisit = false
      this.dialogVisible = ''
      e()
    },
    toDetail(cur) {
      this.dialogCur = cur
      this.dialogVisit = true
      this.dialogVisible = 'detail'
    },
  }
}
</script>
  
<style scoped lang="less">
.header {
  z-index: 1001;
}
.main {
  padding-top: 10px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 6px;
  .box {
    min-height: calc(100vh - 154px);
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
    .filter {
      margin-bottom: 20px;
      h4 {
        // margin-bottom: 8px;
        // padding-left: 12px;
        background: #fff;
        color: rgb(16, 16, 16);
        font-size: 20px;
        font-weight: 400;
        line-height: 2em;
      }
      .el-button {
        width: 100%;
      }
    }
    .renderLabel {
      width: 100px;
    }
    .renderBox {
      display: grid;
      // flex-wrap: wrap;
      // justify-content: space-between;
      grid-template-columns: repeat(3, 1fr);
      // padding-inline-start: 0;
      gap: 20px;
      // padding: 0 30px;
      vertical-align: top;
      .item {
        // position: relative;
        // flex: 0 0 calc(30%);
        gap: 20px;
        // padding: 10px;
        // background: #fff;
        border: 1px solid rgb(187, 187, 187);
        // border-radius: 5px;
        box-sizing: border-box;
        img {
          width: 100%;
          aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
          object-fit: cover;
        }
        .name {
          color: rgba(10,10,10,1);
          font-size: 18px;
          line-height: 36px;
          text-align: center;
        }
      }
    }
  }
}
.el-dialog {
  .img {
    font-size: 0;
    text-align: center;
    img {
      // max-width: 100%;
      // max-height: 70vh;
      // object-fit: contain;
      max-width: 80vw;
      max-height: 70vh;
      object-fit: contain;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/CustomerHistory/Detail.vue